export default __webpack_public_path__ + "static/media/hostfully_step9.e3151355.png";